import './style.scss';
import moment from 'moment';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next'
import React, { useEffect, useState } from 'react';
import leverService from 'src/services/LeverService';
import { Button, DatePicker, Form, Modal, Select, Spin } from 'antd';

const { Option } = Select;

const MatchRequisitionModal = ({ login, reqTitle, reqCode, visible, setVisible, onConfirmMatch }) => {
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allocationTypeOptions, setAllocationTypeOptions] = useState([]);

  const [form] = Form.useForm();

  const { t } = useTranslation();

  const loadAllocationTypeOptions = async () =>{
    setAllocationTypeOptions(await leverService.getOptions());
  }

  useEffect(() => {
    loadAllocationTypeOptions();
  }, [])

  const handleNext = () => {
    setVisible(false);
    setConfirmVisible(true);
  };

  const handleConfirm = async () => {
    setLoading(true);
    
    const { startDate, allocationType } = form.getFieldsValue();
    await onConfirmMatch(startDate, allocationType)
    setLoading(false);
    setConfirmVisible(false);
  };

  const onClosureFormSubmit = (data) => {
    form.submit(data);
  }

  const onClosureFormCancel = () => {
    form.resetFields();
    setVisible(false);
  }

  const onMatchFormCancel = () => {
    setConfirmVisible(false)
    setVisible(true);
  }

  return (
    <div>
      <Modal
        visible={visible}
        title="Closure information"
        className="requisition-modal"
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" className="cancel" onClick={onClosureFormCancel}>
            {t('cancel')}
          </Button>,
          <Button key="confirm" type="primary" onClick={onClosureFormSubmit}>
            {t('next')}
          </Button>,
        ]}
      >
        <div className="requisition-modal-content">
          <Form 
            form={form}
            onFinish={handleNext} 
            data-test-id="closure-requisition" 
          >
            <label htmlFor="startDate" className="form-label">{t('startDate')}</label>
            <Form.Item name="startDate" rules={[{ required: true, message: 'requiredField'}]} >
              <DatePicker 
                placeholder=""
                disabledDate={current => {
                  return current && current < moment().subtract(1, 'day').endOf('day');
                }}
                className="requisition-modal-input start-date" 
              />
            </Form.Item>

            <label htmlFor="allocationType" className="form-label">{t('allocationType')}</label>
            <Form.Item name="allocationType" rules={[{ required: true, message: 'requiredField', }]}>
              <Select className="requisition-modal-input allocation-type" placeholder="">
                {allocationTypeOptions.map(option => 
                  <Option key={option} value={option}>{option}</Option>
                )}
              </Select>
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <Modal
        visible={confirmVisible}
        title="Match confirmation"
        onCancel={onMatchFormCancel}
        footer={[
          <Button key="back" onClick={onMatchFormCancel} disabled={loading}>
            {t('back')}
          </Button>,
          <Button key="confirm" type="primary" onClick={handleConfirm} disabled={loading}>
            {t('confirm')}
          </Button>,
        ]}
      >
        {loading ? <Spin className='loading-spin'/> : <div dangerouslySetInnerHTML={{ __html: t('confirmMatchMessage', {login, reqTitle, reqCode})}}/>}
      </Modal>
    </div>
  );
};

MatchRequisitionModal.propTypes = {
  login: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired, 
  reqCode: PropTypes.number.isRequired, 
  setVisible: PropTypes.func.isRequired, 
  reqTitle: PropTypes.string.isRequired,
  onConfirmMatch: PropTypes.func.isRequired
}

export default MatchRequisitionModal;